// extracted by mini-css-extract-plugin
export default {"container":"ErrorModal_container__gq5WO","backDrop":"ErrorModal_backDrop__ttrTy","modal":"ErrorModal_modal__dGfBl","closeIcon":"ErrorModal_closeIcon__S3mii"};